export default "__VITE_ASSET__B6jI2gCL__"